import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Logger } from '@app/core/logger.service';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
const log = new Logger('SearchPostClickMeetingComponent');

@Component({
  selector: 'app-search-post-click-meeting',
  templateUrl: './search-post-click-meeting.component.html',
  styleUrls: ['./search-post-click-meeting.component.scss'],
})
export class SearchPostClickMeetingComponent implements OnInit {
  searchTerm = '';
  posts: any[] = [];
  item: any;
  item2: any;
  searchType: 'title' | 'id' = 'title';

  constructor(
    private modalCtrl: ModalController,
    private afs: AngularFirestore,
    private alertController:AlertController,
    private toastCtrl: ToastController
  ) { }

  ngOnInit() { }


  removeAccents(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  stringSearch(str: string, whiteSpaces?: boolean): string {
    str = str.trim();
    var noTildes: string = this.removeAccents(str);
    let regexp: RegExp = /[^a-zA-Z0-9]/g;
    if (whiteSpaces === true) {
      regexp = /[^a-zA-Z0-9 ]/g;
    }
    let search: string = noTildes.replace(regexp, '').toLocaleLowerCase();
    search = search.replace(/^\s+|\s+$|\s+(?=\s)/g, '');
    return search;
  };

  async searchPost(text: string) {
    try {
      const trimmedText = (text ?? '').trim();
      if (!trimmedText) {
        this.posts = [];
        return;
      }

      const ref = this.afs.doc('categories/6748').ref;
      const resp = await this.afs.collection('posts').ref.where('category', '==', ref).get();

      this.posts = resp.docs
        .map(item => {
          const data: any = item.data();
          const id: string = item.id;
          return { id, ...data };
        })
        .filter(post => {
          if (this.searchType === 'id') {
            return String(post?.id ?? '').toLowerCase().includes(trimmedText.toLowerCase());
          }

          const query = this.stringSearch(trimmedText, true);
          if (query.length <= 4) {
            return false;
          }

          const title = this.stringSearch(post?.title ?? '', true);
          const excerpt = this.stringSearch(post?.excerpt ?? '', true);
          return title.includes(query) || excerpt.includes(query);
        });
    } catch (error) {
      log.error(error);
    }
  }

  onSearchChange(event: any) {
    this.searchTerm = event.detail?.value ?? event.target?.value ?? this.searchTerm;
  }

  onSearchCancel() {
    this.searchTerm = '';
    this.posts = [];
  }

  changeSearchType(type: 'title' | 'id') {
    this.searchType = type;
    this.posts = [];
    if (this.searchTerm) {
      this.searchPost(this.searchTerm);
    }
  }

  onSearchEnter(event: any) {
    const key = event.key ?? event.keyCode;
    if (key === 'Enter' || key === 13) {
      this.searchPost(this.searchTerm);
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async selectPost(idPost: string) {
    try {
      await this.afs.doc(`posts/${idPost}`).update({ roomId: String(this.item2?.id) });
      this.presentToast(`Entrada asignada a la sesión virtual: ${this.item2?.id}`);
      this.modalCtrl.dismiss({ selectedPostId: idPost });
    } catch (error) {
      log.error(error);
    }
  }

    async alertConfirm(idPost: string) {
    const alert = await this.alertController.create({
      header: `Seleccionar Entrada`,
      message: `Esta acción asignará la entrada(${idPost}) a la sesión: ${this.item2?.id}, ¿Esta seguro de esta acción?`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Seleccionar',
          cssClass: 'secondary',
          handler: () => {
            this.selectPost(idPost);
          }
        }
      ]
    });
    await alert.present();
  }

  async presentToast(message: string) {
        const toast = await this.toastCtrl.create({ message, duration: 3000, position: 'bottom' });
        toast.present();
    }

}
